import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { BuySharedFrequentlyAskedQuestionItem } from './BuySharedFrequentlyAskedQuestionItem';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

import styles from './BuySharedFrequentlyAskedQuestions.scss';

const BuySharedFrequentlyAskedQuestionsComponent = ({ buyPage: { frequentlyAskedQuestions } }) => {
    const [expandedItem, setExpandedItem] = useState(-1);
    const { isMobile } = useContext(ServerVarsContext);

    const title = (
        <FormattedMessage
            id="buy.frequentlyAskedQuestions"
            defaultMessage="Frequently Asked Questions"
        />
    );
    const Header = isMobile ? (
        <div className={styles.mobileHeader}>{title}</div>
    ) : (
        <BarHeader title={title} />
    );

    if (!frequentlyAskedQuestions || !frequentlyAskedQuestions.length) {
        return null;
    }

    return (
        <div className={styles.wrapper}>
            {Header}
            <div>
                {frequentlyAskedQuestions.map(({ question, answer }, index) => {
                    return (
                        <BuySharedFrequentlyAskedQuestionItem
                            key={question}
                            index={index}
                            question={question}
                            answer={answer}
                            isExpanded={index === expandedItem}
                            onClick={setExpandedItem}
                        />
                    );
                })}
            </div>
        </div>
    );
};

BuySharedFrequentlyAskedQuestionsComponent.propTypes = {
    buyPage: PropTypes.object.isRequired,
};

export const BuySharedFrequentlyAskedQuestions = createFragmentContainer(
    BuySharedFrequentlyAskedQuestionsComponent,
    {
        buyPage: graphql`
            fragment BuySharedFrequentlyAskedQuestions_buyPage on BuyPageConnection {
                frequentlyAskedQuestions {
                    question
                    answer
                }
            }
        `,
    }
);
